import React, { Component } from "react";
import { Flex } from "../../styles/GlobalStyle.js";
import "react-responsive-modal/styles.css";
import { TitleOrder, Detail, Container, Notes } from "./styles/SuccessStyle.js";
import Property from "../../model/property";
import { get, isEmpty, isUndefined } from "lodash";
import moment from "moment";
import { withTranslation } from "react-i18next";
import FulfillmentNode from "../../model/fulfillmentNode";
import {
  Status,
  StatusValue,
  Subtotal,
  TitleName,
} from "../finishorder/style/SuccessStyle";
import { Avatar } from "@material-ui/core";
import BrandStyleSheet from "../precheckin/BrandStyleSheet";
import TopBar from "../../components/navbar/TopBar";
import { TopPadding, ItemWrap } from "./LobbyrowStyle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { LazyLoadImage } from "react-lazy-load-image-component";
import storeFunction from "../../utils/storeFunction";

class SuccessFulfillment extends Component {
  state = {
    order: {},
    errorModalStatus: false,
    fulfillmentNode: {},
    presets: {},
    notes: "",
    photos: [],
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    const orderSuccess = Property.getOrderSuccess();
    const notes = Property.getNoteItemSelection();
    const presets = Property.getPreset();
    if (presets && !isEmpty(presets.app_webstore_favicon_url)) {
      const favicon = document.getElementById("favicon");
      if (favicon) favicon.href = presets.app_webstore_favicon_url;
      const appleFavicon = document.getElementById("apple-favicon");
      if (appleFavicon) appleFavicon.href = presets.app_webstore_favicon_url;
    }
    this.setState({
      fulfillmentNode: FulfillmentNode.getData(),
      order: orderSuccess,
      notes: notes,
      presets: presets,
      photos: FulfillmentNode.getUploadedPhotos(),
    });
    FulfillmentNode.clearCartItem();
  }

  componentDidUpdate() {
    if (isEmpty(this.state.preset) && !isUndefined(Property.getPreset())) {
      this.setState({ preset: Property.getPreset() });
    }
  }

  render() {
    const { order, presets, notes, fulfillmentNode, photos } = this.state;
    const createAt = get(order, "data.created_at");
    return (
      <Container
        className={"sectionContent"}
        id="list-container">
        <div className="flex flex-col w-full">
          <BrandStyleSheet brandStyleSheet={presets.app_brand_stylesheet} />
          <div className="flex flex-col mb-20">
            <TopBar title="My Request Detail" />
            <TopPadding className="lg:hidden" />
            {order && (
              <>
                <Flex
                  container
                  flex={1}
                  margin="15px"
                  alignItems="center">
                  <ItemWrap className="flex">
                    {fulfillmentNode.icon_type === "Font" &&
                      fulfillmentNode.font_icon.length > 0 && (
                        <FontAwesomeIcon
                          icon={
                            require("@fortawesome/free-solid-svg-icons")[
                              `fa${
                                fulfillmentNode.font_icon
                                  .charAt(0)
                                  .toUpperCase() +
                                fulfillmentNode.font_icon.slice(1)
                              }`
                            ]
                          }
                        />
                      )}
                  </ItemWrap>
                  <TitleOrder
                    className={"finishTitle"}
                    style={{ paddingLeft: "10px" }}>
                    {fulfillmentNode && fulfillmentNode.title}
                  </TitleOrder>
                </Flex>
                <hr />
                <Flex
                  container
                  flex={1}
                  margin="15px"
                  alignItems="center"
                  justifyContent="space-between">
                  <Subtotal
                    fontSize="12px"
                    color="gray">
                    {this.props.t("ASSIGNED_TO")}
                  </Subtotal>
                </Flex>
                <Flex
                  container
                  flex={1}
                  margin="15px"
                  alignItems="center"
                  justifyContent="space-between">
                  <Flex
                    container
                    alignItems="center">
                    <Avatar src={get(order, "data.staff_detail.avatar")} />
                    <Flex margin="0 0 0 5px">
                      <TitleName>
                        {get(order, "data.staff_detail.full_name")}
                      </TitleName>
                      <Detail>{get(order, "data.staff_detail.role")}</Detail>
                    </Flex>
                  </Flex>
                  <Flex>
                    <Status>{this.props.t("STATUS")}</Status>
                    <StatusValue
                      app_home_color_primary={presets.app_home_color_primary}>
                      {get(order, "data.status")}
                    </StatusValue>
                  </Flex>
                </Flex>
                <hr />
                <Flex
                  container
                  flex={1}
                  margin="15px"
                  alignItems="center"
                  justifyContent="space-between">
                  <Detail>Room: {get(order, "data.room_number")}</Detail>
                  <Detail>{`${this.props.t("CREATED")}: ${moment(
                    createAt
                  ).format("h:mma L")}`}</Detail>
                </Flex>
                <Flex
                  container
                  margin="15px"
                  flexDirection="column">
                  <Detail>
                    Request Type: {get(order, "data.generic_type")}
                  </Detail>
                  <Notes>{notes}</Notes>
                </Flex>
                {photos &&
                  Array.from(photos).map(
                    (photo) =>
                      photo && (
                        <Flex
                          container
                          margin="15px"
                          flexDirection="column">
                          <Detail style={{ marginBottom: "10px" }}>
                            Photo Type: {get(photo, "title")}
                          </Detail>
                          <LazyLoadImage
                            alt={get(photo, "title")}
                            src={storeFunction.resizeImage(
                              get(photo, "url"),
                              600,
                              600
                            )}
                            wrapperClassName="w-full h-50"
                            style={{
                              objectFit: "cover",
                              width: "100%",
                              maxHeight: `200px`,
                              maxWidth: `200px`,
                              display: "absolute",
                            }}
                          />
                        </Flex>
                      )
                  )}
              </>
            )}
          </div>
        </div>
      </Container>
    );
  }
}

export default withTranslation()(SuccessFulfillment);
